module.exports = __webpack_public_path__ + "assets/img/d95737b6fb5aab6d5694bbd1b8e00b8a.png";